import { BillingEnv, Env, MeteringMemberUsage, MeteringMessengerUsage } from '@@types/Api';
import { Subscription } from '@@types/Api/Common';
import Auth from '@@types/Auth';
import { MEMBER_ID } from '@@types/common';

import { URLS } from '~/constants';
import { SECOND } from '~/constants/date';
import Api2 from '~/stores/providers/Api2';

import * as packageJson from '../../../../package.json';

class CommonApi {
  constructor(private api: Api2) {}

  fetchAuth = (): Promise<Auth> => {
    return this.api.contentsRequester.get(`${URLS.API}/members/me?v=${packageJson.version}`);
  };

  fetchSubscription = (): Promise<Subscription> => {
    return this.api.contentsRequester.get(`${URLS.WAS_API}/subscription`);
  };

  fetchMessengerUsage = (): Promise<MeteringMessengerUsage> => {
    return this.api.ignoreErrorRequester
      .cancelGet(`${URLS.WAS_API}/metering/messenger-usage`, '', {
        timeout: 5 * SECOND,
      })
      .then((res) => res.data.result);
  };

  fetchMyUsage = (memberId: MEMBER_ID): Promise<MeteringMemberUsage> => {
    return this.api.ignoreErrorRequester
      .get(`${URLS.WAS_API}/metering/members/${memberId}/detail-usage`, {
        timeout: 5 * SECOND,
      })
      .then((res) => res.data.result);
  };

  fetchServiceAcl = (): Promise<Env> => {
    return this.api.resultRequester.get(`${URLS.WAS_API}/env`);
  };

  fetchBillingEnv = (): Promise<BillingEnv> => {
    return this.api.resultRequester.get(`${URLS.BILLING_API}/env`);
  };

  healthCheck = (): Promise<string> => {
    return this.api.ignoreErrorRequester.get(`${URLS.INNER_API}/health-check`);
  };

  getAuthToken = (memberId: string): Promise<{ token: string }> => {
    return this.api.contentsRequester.post(`${URLS.API}/members/${memberId}/token`);
  };

  getHelpMailDomain = (): Promise<string> => {
    return this.api.rawRequester.get('/static_html/help-mail-domain.json', {
      headers: { 'Dooray-User-Interaction': 'false' },
    });
  };
}

export default CommonApi;
